import { render, staticRenderFns } from "./ItineraryDestinationCard.vue?vue&type=template&id=72f9d1c2&scoped=true"
import script from "./ItineraryDestinationCard.vue?vue&type=script&lang=ts"
export * from "./ItineraryDestinationCard.vue?vue&type=script&lang=ts"
import style0 from "./ItineraryDestinationCard.vue?vue&type=style&index=0&id=72f9d1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9d1c2",
  null
  
)

export default component.exports